import React from 'react';
import "./Collections.css";

const Collections = function (props) {
    return (       
        <React.Fragment>
                <div className="cardRoot">
                    <div className="collectionsImgPart" >
                        <a href={props.data.MuseumCollectionItemImg_Url} target="_blank">
                            <img className="imgCollectionsWebPart" src={props.data.MuseumCollectionItemImg_Url + "?RenditionID=6"} data-holder-rendered="true"  alt={"תמונת "+ props.data.LinkTitle}/>
                        </a>
                    </div>
                    <div className="collectionsInformation">
                        <div className= "collectionMainDivTitle">
                            <span className="collectionSubTitle">{props.data.LinkTitle}</span>
                        </div>
                        <div className= "infoCollectionItemContainer">
                            {props.data.MuseumCollectionItemDescription != null ?
                                <div className="collectionItemInformation">
                                    <span>
                                        {props.data.MuseumCollectionItemDescription}
                                    </span>
                                </div> : null}
                            
                        </div>
                    </div>  
                </div>
            </React.Fragment>
    );
}

export default Collections;
